import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const MasooliatMadaniApiPaths: IPaths = {
  BimehNamehHayeMadani: {
    GetBimehNamehHayeMadaniPagedFilter: 'BimehNamehHayeOmumi/GetBimehNamehHayeMadaniPagedFilter',
    GetShomarehBimehHayeMadani: 'BimehNamehHayeOmumi/GetShomarehBimehNamehHayeMadani',
    GetBimehMadani: 'BimehNamehHayeOmumi/GetBimehNamehMadaniDetail',
    PrintBimehNamehMadani: 'BimehNamehHayeOmumi/PrintBimehNamehMadani',
    GetPrintBimehNamehMadaniDisplay: 'BimehNamehHayeOmumi/GetPrintBimehNamehMadaniDisplay',
    Estelam: 'BimehNamehHayeOmumi/EstelamAsansor',
    CreateShenasehPardakht: 'BimehNamehHayeOmumi/CreateShenasehPardakhtAsansor',
    AddToOrder: 'BimehNamehHayeOmumi/AddToOrderWepod',
    BimehNamehMasooliatMadaniOmumiSaderShodeh: 'BimehNamehHayeOmumi/BimehNamehSaderShodeh',
    PrintElhaghiyehMadani: 'BimehNamehHayeOmumi/PrintElhaghiyehMadani',
    GetElhaghiyehHayeSadereh: 'BimehNamehHayeOmumi/GetElhaghiyehHayeSadereh',
    PrintBimehNamehMadaniById: 'BimehNamehHayeOmumi/PrintBimehNamehMadaniById',
  },
  mozuFaaliatOmumi: {
    GetMozuatFaaliatOmumi: 'MozuFaaliatOmumi/GetMozuatFaaliatOmumi',
  },
  poosheshMasooliatMadani: {
    getActivePoosheshHayeMasooliatMadani: 'PoosheshMasooliatMadani/GetActivePoosheshHayeMasooliatMadani',
  },
  taahodHazinehPezeshki: {
    getActiveTaahodatHazinehPezeshki: 'TaahodHazinehPezeshki/getActiveTaahodatHazinehPezeshki',
  },
};
